import {
  CLIENT_SCOPE_DESCRIPTION_REQUIRED,
  isClientScopeDescriptionMissing,
} from '@shared/schemas';

import {
  validateListName,
  validateListPeriod,
} from '../../_shared/domain/list-field-validation';
import type { EditDraft } from './edit-draft.model';

/** Field-level validation errors, keyed by draft field name. Empty = valid. */
export type ValidationErrors = Partial<Record<keyof EditDraft, string>>;

/**
 * Pure business validation for an edit draft. Composes the shared name/period
 * validators. Unlike Add, Edit does not require a licence (fixed on the loaded
 * entity) or a selected method (the wizard can go straight to confirm), which
 * mirrors the original inline `isValid` rule. No React, no Redux.
 */
export function validateDraft(draft: EditDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  const nameError = validateListName(draft.name);
  if (nameError) errors.name = nameError;
  Object.assign(errors, validateListPeriod(draft.startDate, draft.endDate));
  // Same rule as the server (#718): a list saved as sent carries its
  // client-facing description, unless it is a client's own import (#722).
  if (isClientScopeDescriptionMissing(draft.status, draft.clientScopeDescription, draft.origin)) {
    errors.clientScopeDescription = CLIENT_SCOPE_DESCRIPTION_REQUIRED;
  }

  return errors;
}
